<template>
  <Modal v-model="show" :mask-closable="false"  @on-ok="showAction">
    <div slot="header" class="modal-header">{{text}}</div>   
    <p>确认要{{text}}该房间吗?</p>
  </Modal> 
</template>
 
<script type="text/ecmascript-6">
import { showOrHideHouse } from "api/house"

export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    subStockShowKey:{
      type:Number,
      default:0
    },
    showType:{
      type:Number,
      default:0
    },
    stockFid:{
      type:String,
      default:''
    },
  },
  computed:{
    text() {
      return this.showType===0 ? '隐藏' :'显示'
    }
  },
  data () {
    return {
       show:false
    };
  },
  watch:{
   n(val){
     this.show = true;
   },
   subStockShowKey() {
     this.show=true;
   }
 },
  methods:{
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
    },
    showAction(){
      let stockFid = this.stockFid
      let showType = this.showType
      showOrHideHouse({ stockFid:stockFid,isShow:showType }).then(res => {
        this.changeLoading();
        this.$Message.success(`${this.text}成功`);
        this.show = false;
        this.$emit('refresh')
      }).catch(error => {
        this.changeLoading(); 
      })  
   }
  }
}
</script>
